import "../../styles/all.css"
import "../../styles/theme.css"
import "./vistor.css"
import VisitorOverview from "../draw/overview"
function Vistor(){
    return(
        <>
        <div className="vistor">
             <div className="startt">
                <h4>Vistor Overview</h4>
            </div>
            <div className="spreate">
                
            </div>
            <div className="end">
                <VisitorOverview/>

            </div>
        </div>
        </>
    )
}
export default Vistor